import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import FontAwesome from 'react-fontawesome';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import utils from '../../common/services/utils';

const List = ({ t, enableUserTimeZone, ...rest }) => {
	const columns = [
		{
			header: t('FO_Payment_Child'),
			accessor: 'child.shortName',
			className: 'green'
		},
		{
			header: t('FO_IndividualConsultation_Type'),
			accessor: 'consultationType',
			cell: consultationType => t(`IndividualConsultationType_${consultationType}`)
		},
		{
			header: t('FO_IndividualConsultation_Date'),
			accessor: 'consultationDate',
			cell: (date, row) => (enableUserTimeZone ? utils.convertToUserTime(date, row.center) : moment(date)).format('lll')
		},
		{
			header: t('FO_Payment_Created'),
			accessor: 'created',
			cell: created => moment(created).format('lll')
		},
		{
			header: '',
			accessor: 'id',
			cell: (id, payment) => (<span>
				{payment.requiresQuestionnaire && <FontAwesome name='exclamation-triangle' />}
				{payment.documents.filter(d => d.fromParent).length > 0 && <FontAwesome name='paperclip' />}
			</span>)
		},
		{
			header: '',
			accessor: 'id',
			cell: (id, payment) => <Link to={`/individual-consultation/${id}`}>{t('FO_IndividualConsultation_Details')}</Link>
		}
	];

	return (
		<div>
			<PagedEntitiesList columns={columns} {...rest} />
		</div>
	);
};

List.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		child: PropTypes.shape({
			shortName: PropTypes.string
		}),
		center: PropTypes.shape({
			name: PropTypes.string
		}),
		consultationDate: PropTypes.string,
		created: PropTypes.string
	}))
};

export default withTranslation()(List);